import { createContext, useContext } from "react";
import type { ImpersonationContextValue } from "./ImpersonationContext.types";
import { useImpersonationContextViewModel } from "./ImpersonationContext.vm";

const ImpersonationContext = createContext<ImpersonationContextValue>({
	impersonatedEmail: null,
	isImpersonating: false,
	startImpersonation: () => {},
	stopImpersonation: () => {},
});

export function ImpersonationContextProvider({ children }: { children: React.ReactNode }) {
	const value = useImpersonationContextViewModel();
	return <ImpersonationContext.Provider value={value}>{children}</ImpersonationContext.Provider>;
}

export function useImpersonationContext(): ImpersonationContextValue {
	return useContext(ImpersonationContext);
}

export { ImpersonationContext };
